module.exports = __webpack_public_path__ + "img/logo-white.88bc5115.png";